var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-card",
    { staticClass: "mt-30", class: _vm.analysisScoreClass },
    [
      _c(
        "div",
        {
          staticClass: "analysis-header-row",
          class: { "no-eval-padding": !_vm.hasEvaluation },
          on: { click: _vm.toggle }
        },
        [
          _c("div", { staticClass: "analysis-header-left" }, [
            _c("strong", { staticClass: "upper-word" }, [
              _vm._v("Request Evaluation")
            ]),
            _vm._v(" "),
            _vm.recommendedScore
              ? _c(
                  "span",
                  {
                    staticClass: "approval-verdict-badge",
                    class: {
                      "verdict-approve": _vm.recommendedScore === "Approve",
                      "verdict-caution":
                        _vm.recommendedScore === "Approve with Caution",
                      "verdict-reject":
                        _vm.recommendedScore === "Do Not Approve"
                    }
                  },
                  [
                    _c("i", {
                      class: {
                        "fa fa-check-circle":
                          _vm.recommendedScore === "Approve",
                        "fa fa-exclamation-circle":
                          _vm.recommendedScore === "Approve with Caution",
                        "fa fa-times-circle":
                          _vm.recommendedScore === "Do Not Approve"
                      }
                    }),
                    _vm._v("\n        " + _vm._s(_vm.verdictLabel) + "\n      ")
                  ]
                )
              : _vm.hasEvaluation
              ? _c(
                  "span",
                  { staticClass: "approval-verdict-badge verdict-caution" },
                  [
                    _c("i", { staticClass: "fa fa-exclamation-circle" }),
                    _vm._v("\n        Incomplete\n      ")
                  ]
                )
              : _c(
                  "span",
                  { staticClass: "approval-verdict-badge verdict-none" },
                  [_vm._v("\n        No Evaluation Yet\n      ")]
                )
          ]),
          _vm._v(" "),
          _c("i", {
            staticClass: "fa fa-chevron-down analysis-chevron",
            class: { "analysis-chevron--open": _vm.isOpen }
          })
        ]
      ),
      _vm._v(" "),
      _vm.summaryText && !_vm.isOpen
        ? _c("p", { staticClass: "analysis-summary-preview" }, [
            _vm._v(_vm._s(_vm.summaryText))
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("transition", { attrs: { name: "slide" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isOpen,
                expression: "isOpen"
              }
            ],
            staticClass: "analysis-body"
          },
          [
            !_vm.isEvaluating && !_vm.errorMessage && _vm.evaluatedAtLabel
              ? _c("p", { staticClass: "analysis-timestamp" }, [
                  _c("i", {
                    staticClass: "far fa-clock",
                    staticStyle: { "margin-right": "4px" }
                  }),
                  _vm._v(
                    "Last evaluated " +
                      _vm._s(_vm.evaluatedAtLabel) +
                      "\n      "
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.isEvaluating
              ? _c(
                  "div",
                  {
                    staticClass: "analysis-failed-state",
                    staticStyle: {
                      background: "rgba(99,102,241,0.06)",
                      "border-color": "rgba(99,102,241,0.2)"
                    }
                  },
                  [
                    _c("md-progress-spinner", {
                      attrs: {
                        "md-mode": "indeterminate",
                        "md-diameter": 20,
                        "md-stroke": 2
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        staticClass: "analysis-explanation",
                        staticStyle: {
                          "margin-top": "10px",
                          "margin-bottom": "0"
                        }
                      },
                      [_vm._v("Analyzing request...")]
                    )
                  ],
                  1
                )
              : _vm.errorMessage
              ? _c("div", { staticClass: "analysis-failed-state" }, [
                  _c(
                    "p",
                    {
                      staticClass: "analysis-explanation",
                      staticStyle: { "margin-bottom": "12px" }
                    },
                    [
                      _c("i", {
                        staticClass: "fa fa-exclamation-triangle",
                        staticStyle: { color: "#e65100", "margin-right": "6px" }
                      }),
                      _vm._v(
                        "\n          " + _vm._s(_vm.errorMessage) + "\n        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "generate-eval-btn",
                      attrs: { type: "button", disabled: _vm.isEvaluating },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.generate.apply(null, arguments)
                        }
                      }
                    },
                    [
                      _c("i", {
                        staticClass: "fa fa-rotate-left",
                        staticStyle: { "margin-right": "6px" }
                      }),
                      _vm._v("\n          Try again\n        ")
                    ]
                  )
                ])
              : !_vm.hasEvaluation
              ? _c("div", { staticClass: "analysis-failed-state" }, [
                  _c(
                    "p",
                    {
                      staticClass: "analysis-explanation",
                      staticStyle: { "margin-bottom": "12px" }
                    },
                    [
                      _vm._v(
                        "\n          No evaluation generated yet for this request.\n        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "generate-eval-btn",
                      attrs: { type: "button", disabled: _vm.isEvaluating },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.generate.apply(null, arguments)
                        }
                      }
                    },
                    [
                      _c("i", {
                        staticClass: "fa fa-magic",
                        staticStyle: { "margin-right": "6px" }
                      }),
                      _vm._v("\n          Generate evaluation\n        ")
                    ]
                  )
                ])
              : !_vm.recommendedScore
              ? _c("div", { staticClass: "analysis-failed-state" }, [
                  _c(
                    "p",
                    {
                      staticClass: "analysis-explanation",
                      staticStyle: { "margin-bottom": "12px" }
                    },
                    [
                      _c("i", {
                        staticClass: "fa fa-exclamation-triangle",
                        staticStyle: { color: "#e65100", "margin-right": "6px" }
                      }),
                      _vm._v(
                        "\n          The evaluation could not be completed. This may be due to a temporary service error.\n        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "generate-eval-btn",
                      attrs: { type: "button", disabled: _vm.isEvaluating },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.generate.apply(null, arguments)
                        }
                      }
                    },
                    [
                      _c("i", {
                        staticClass: "fa fa-rotate-left",
                        staticStyle: { "margin-right": "6px" }
                      }),
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.isEvaluating
                              ? "Re-evaluating..."
                              : "Re-evaluate"
                          ) +
                          "\n        "
                      )
                    ]
                  )
                ])
              : _c(
                  "div",
                  [
                    _c(
                      "p",
                      {
                        staticClass: "analysis-explanation",
                        staticStyle: { "margin-bottom": "12px", color: "#444" }
                      },
                      [_vm._v(_vm._s(_vm.summaryText))]
                    ),
                    _vm._v(" "),
                    _c("hr", {
                      staticStyle: {
                        border: "none",
                        "border-top": "1px solid rgba(0,0,0,0.08)",
                        margin: "0 0 14px 0"
                      }
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.activeEvaluation.all_results, function(
                      item,
                      index
                    ) {
                      return _c("div", { key: index }, [
                        item.sentiment
                          ? _c("div", { staticClass: "analysis-section" }, [
                              _c(
                                "div",
                                { staticClass: "analysis-section-header" },
                                [
                                  _c("i", { staticClass: "fa fa-heart" }),
                                  _vm._v(" "),
                                  _c("span", [_vm._v("Sentiment")])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "analysis-section-body" },
                                [
                                  item.sentiment.sentiment_values &&
                                  item.sentiment.sentiment_values.length
                                    ? _c(
                                        "div",
                                        { staticClass: "analysis-badges-row" },
                                        _vm._l(
                                          item.sentiment.sentiment_values,
                                          function(val) {
                                            return _c(
                                              "span",
                                              {
                                                key: val,
                                                staticClass: "sentiment-chip"
                                              },
                                              [_vm._v(_vm._s(val))]
                                            )
                                          }
                                        ),
                                        0
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.sentiment.explanation &&
                                  item.sentiment.explanation.length
                                    ? _vm._l(
                                        item.sentiment.explanation,
                                        function(line, idx) {
                                          return Array.isArray(
                                            item.sentiment.explanation
                                          )
                                            ? _c(
                                                "p",
                                                {
                                                  key: idx,
                                                  staticClass:
                                                    "analysis-explanation"
                                                },
                                                [_vm._v(_vm._s(line))]
                                              )
                                            : _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "analysis-explanation"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      item.sentiment.explanation
                                                    )
                                                  )
                                                ]
                                              )
                                        }
                                      )
                                    : item.sentiment.raw
                                    ? _c("p", {
                                        staticClass: "analysis-explanation",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.formatSentimentRaw(
                                              item.sentiment.raw
                                            )
                                          )
                                        }
                                      })
                                    : _vm._e()
                                ],
                                2
                              )
                            ])
                          : item.good_intents
                          ? _c("div", { staticClass: "analysis-section" }, [
                              _c(
                                "div",
                                { staticClass: "analysis-section-header" },
                                [
                                  _c("i", { staticClass: "fa fa-shield-alt" }),
                                  _vm._v(" "),
                                  _c("span", [_vm._v("Good Intents")])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "analysis-section-body" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "analysis-badges-row" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "analysis-badge",
                                          class: _vm.ratingBadgeClass(
                                            item.good_intents
                                              .non_marketing_email
                                          )
                                        },
                                        [
                                          _c("i", {
                                            class: _vm.ratingIconClass(
                                              item.good_intents
                                                .non_marketing_email
                                            )
                                          }),
                                          _vm._v(
                                            "\n                  Genuine Email\n                "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "analysis-badge",
                                          class: _vm.ratingBadgeClass(
                                            item.good_intents.non_phishing_email
                                          )
                                        },
                                        [
                                          _c("i", {
                                            class: _vm.ratingIconClass(
                                              item.good_intents
                                                .non_phishing_email
                                            )
                                          }),
                                          _vm._v(
                                            "\n                  Safe Email\n                "
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    { staticClass: "analysis-explanation" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          item.good_intents
                                            .marketing_explanation
                                        )
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    { staticClass: "analysis-explanation" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          item.good_intents.phishing_explanation
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            ])
                          : _vm._e()
                      ])
                    })
                  ],
                  2
                )
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3ca92b1b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ca92b1b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ApprovalGuidanceCard.vue
// module id = null
// module chunks = 